import { render } from "./AnimatedArrow.vue?vue&type=template&id=18607796"
import script from "./AnimatedArrow.vue?vue&type=script&lang=js"
export * from "./AnimatedArrow.vue?vue&type=script&lang=js"

import "./AnimatedArrow.vue?vue&type=style&index=0&id=18607796&lang=scss"

import exportComponent from "/home/runner/work/eoy-2022-frontend/eoy-2022-frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__